import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Form,
  Row,
  Col,
  Table,
  Input,
  Dropdown,
  Button,
  Modal,
  Menu,
  Select,
  Tag,
  message,
  Spin,
  Tooltip,
} from "antd";
import { withAppContext } from "../../store/contextStore";
import AppConfigs from "../../Config/AppConfig";
import moment from "moment";
import { list, add, update } from "../../api/Apis";
import { showTotal, ordersSort } from "../commonFunctions";
import PushToCarrier from "../../Components/PushToCarrier";
import AssignToCarrier from "../../Components/AssignToCarrier";
import LoadDelivered from "../../Components/LoadDelivered";
import ErrorPage from "../ErrorPage";
// import generatePDF from './LeadDetailsPdf';
import GeneratePdf from "../../Components/GeneratePdf";
import { createGlobalStyle } from "styled-components";
import ResizableAntdTable from "resizable-antd-table";
import DownloadCsv from "../../Components/DownloadCsv";

const Search = Input.Search;
const { Option } = Select;
const GlobalStyle = createGlobalStyle`
  body {
    .ant-tooltip-inner {
      color: white;
      background-color: "#F0E68C";
      width: 440px;
    }
  }
`;

class Loads extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterData: [],
      loadsList: [],
      defaultStatus: "",
      oraganizationsData: [],
      totalOrdersList: [],
      recordId: "",
      dataLoadingStatus: true,
      pageLoadingStatus: false,
      carrierRequestsModalStatus: false,
      carrierRequests: [],
      columns: [],
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
      showPushToCarrierModal: false,
      defaultColDef: {
        editable: true,
        sortable: true,
        flex: 1,
        minWidth: 100,
        filter: true,
        resizable: true,
      },
    };
  }
  componentDidMount() {
    this.getOrders();
    this.setState({
      columns: [
        { field: "orderId" },
        { field: "subOrderId" },
        { field: "productName" },
        { field: "productOriginDetails" },
        { field: "createdAt" },
        { field: "deliveryReqDate" },
        { field: "orderStatus" },
        { field: "customerName" },
        { field: "location" },
        { field: "assignCarrier" },
        { field: "pickupDate" },
        { field: "deliveryDateAndTime" },
        { field: "deliveryTruck" },
        { field: "callForRate" },
      ],
    });
  }

  getOrders = () => {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let query = {
      orgId: orgDetails["id"],
    };
    list(AppConfigs["entityNames"]["leads"], query).then((result) => {
      if (result.success) {
        let loadList = result.data.sort((a, b) =>
          parseInt(a["orderId"]) < parseInt(b["orderId"]) ? 1 : -1
        );
        this.setState({
          loadsList: loadList,
          totalOrdersList: loadList,
          dataLoadingStatus: false,
          defaultStatus: "",
        });
        console.log('load list:', this.state.loadsList)
      } else {
        this.setState({
          dataLoadingStatus: false,
        });
        console.log(result.errors);
      }
    });
    console.log('load list:', this.state.loadsList)
  };

  addLoad = () => {
    this.props.history.push("/app/loads/addLoad");
  };

  openRateModal = (id) => {
    this.props.form.setFieldsValue({
      rateValue: "",
    });

    this.setState({
      recordId: id,
      rateModalStatus: true,
    });
  };

  orderConfirm = (id) => {
    this.setState({
      dataLoadingStatus: true,
    });
    let data = {
      entityData: {
        orderStatus: AppConfigs["ORDER_PROCESSED"],
        orderProcessedTime: moment().valueOf(),
      },
    };
    this.recordUpdate(id, data, "Order confirm Successfully");
  };

  recordUpdate = (id, data, disMsg) => {
    update(AppConfigs["entityNames"]["leads"], id, data).then((result) => {
      if (result.success) {
        message.success(disMsg);
        this.getOrders();
      } else {
        this.setState({
          dataLoadingStatus: false,
        });
        console.log(result.errors);
      }
    });
  };

  markAsStatus = (markAsId, id) => {
    this.setState({
      dataLoadingStatus: true,
    });
    let data = {
      entityData: {
        [markAsId]: true,
      },
    };
    this.recordUpdate(id, data, "Record updated successfully");
  };

  searchData = (event, searchType) => {
    let searcingValue = searchType === "text" ? event.target.value : event;
    let totalOrdersList = [];
    if (searcingValue.length > 0) {
      searcingValue = searcingValue.toLowerCase();
      if (searchType === "text") {
        this.setState({
          defaultStatus: "",
        });
        totalOrdersList = this.state.totalOrdersList.filter(
          (load) =>
            load?.orderId?.toString() === searcingValue ||
            load?.customerName?.toLowerCase().indexOf(searcingValue) > -1 ||
            load?.companyName?.toLowerCase().indexOf(searcingValue) > -1 ||
            (load?.address !== null &&
              load.address?.toLowerCase().indexOf(searcingValue) > -1) ||
            (load["cartItems"][0]["address"] &&
              load["cartItems"][0]["address"] !== null &&
              load["cartItems"][0]["address"].split(",").length > 0 &&
              load["cartItems"][0]["address"]
                .split(",")[0]
                .toLowerCase()
                .indexOf(searcingValue) > -1) ||
            (load["cartItems"][0]["address"] &&
              load["cartItems"][0]["address"] !== null &&
              load["cartItems"][0]["address"].split(",").length > 0 &&
              load["cartItems"][0]["address"]
                .split(",")[1]
                .toLowerCase()
                .indexOf(searcingValue) > -1) ||
            ("productName" in load &&
              load.productName != null &&
              load.productName.toLowerCase().indexOf(searcingValue) > -1) ||
            ("carrierDetails" in load &&
              "carrierName" in load.carrierDetails &&
              load.carrierDetails.carrierName !== null &&
              load.carrierDetails.carrierName
                .toLowerCase()
                .indexOf(searcingValue) > -1) ||
            ("productOriginDetails" in load &&
              "locationName" in load.productOriginDetails &&
              load.productOriginDetails.locationName !== null &&
              load.productOriginDetails.locationName
                .toLowerCase()
                .indexOf(searcingValue) > -1) ||
            ("poNumber" in load &&
              load.poNumber.toLowerCase().indexOf(searcingValue) > -1)
        );
      } else {
        this.setState({
          defaultStatus: event,
          dataLoadingStatus: false,
        });
        // if (searcingValue === "pcp") {
        //   totalOrdersList = this.state.totalOrdersList.filter(
        //     (load) =>
        //       load.deliveryTruck === "CustomerPickup" &&
        //       load.orderStatus === "OP" &&
        //       load
        //   );
        // }
        // else if (searcingValue === "cp") {
        //   totalOrdersList = this.state.totalOrdersList.filter(
        //     (load) =>
        //       load.deliveryTruck === "CustomerPickup" &&
        //       load.orderStatus === "D" &&
        //       !load["markAsPaid"] &&
        //       !load["markAsInvoiced"] &&
        //       load
        //   );
        // }
        // else if (searcingValue === "d") {
        //   totalOrdersList = this.state.totalOrdersList.filter(
        //     (load) =>
        //       // !load["markAsPaid"] &&
        //       // load.deliveryTruck !== "CustomerPickup" &&
        //       load.orderStatus.toLowerCase() === searcingValue
        //       // && !load["markAsInvoiced"]
        //   );
        // } else if (searcingValue === "inv") {
        //   totalOrdersList = this.state.totalOrdersList.filter(
        //     (load) =>
        //       load.orderStatus === "INV"
        //   );
        // } else if (searcingValue === "paid") {
        //   totalOrdersList = this.state.totalOrdersList.filter(
        //     (load) =>
        //       load.orderStatus === "PAID"
        //   );
        // } else if (searcingValue === "R") {
        //   totalOrdersList = this.state.totalOrdersList.filter(
        //     (load) => load.orderStatus === "R"
        //   );
        // }
        // else if (searcingValue === "op") {
        //   totalOrdersList = this.state.totalOrdersList.filter(
        //     (load) =>
        //       // "markAsPaid" in load &&
        //       // load["markAsPaid"] !== true &&
        //       // load["measurementType"] !== "Pallet" &&
        //        load.orderStatus === "OP"
        //   );
        // }
        // else if (searcingValue === "pc") {
        //   totalOrdersList = this.state.totalOrdersList.filter(
        //     (load) =>
        //       load.orderStatus.toLowerCase() === searcingValue
        //       //  &&
        //       // !load.carrierRequests
        //   );
        // }
        // else {
        totalOrdersList = this.state.totalOrdersList.filter(
          (load) => load.orderStatus.toLowerCase() === searcingValue
        );
        // }
      }
    } else {
      totalOrdersList = this.state.totalOrdersList;
      this.setState({
        defaultStatus: "",
      });
    }
    this.setState({
      loadsList: totalOrdersList,
    });
  };

  LoadAssign = (id) => {
    this.setState({
      dataLoadingStatus: true,
    });
    let data = {
      entityData: {
        requestId: id,
        orderStatus: AppConfigs["ASSIGN_TO_CARRIER"],
      },
    };
    add(AppConfigs["approveLoadAssignment"], data).then((result) => {
      if (result.success) {
        this.setState({
          carrierRequestsModalStatus: false,
        });
        message.success("Load assigned successfully!");
        this.getOrders();
      } else {
        this.setState({
          loading: false,
        });
      }
    });
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };

  hidePushToCarrierModal = () => {
    this.setState({ showPushToCarrierModal: false });
  };

  render() {
    const columns = [
      {
        title: <div style={{ color: "grey" }}>Order</div>,
        dataIndex: "orderId",
        key: "orderId",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (id, record) => (
          <div style={{ color: "black" }}>
            <Tooltip
              overlayStyle={{ whiteSpace: "pre-line" }}
              style={{ width: "1000px" }}
              arrowPointAtCenter
              getPopupContainer={(triggerNode) => triggerNode}
              title={`Order:${record?.orderId}
              Sub Order#:${record?.subOrderId}
              Product Name:${record?.productName}
              Loading Location Company:${
                Array.isArray(record["productOriginDetails"])
                  ? record["productOriginDetails"]?.map((item, index) =>
                      index === record.length - 1
                        ? item.locationName
                        : item.locationName
                    )
                  : record["productOriginDetails"]["locationName"]
                  ? record["productOriginDetails"]["locationName"]
                  : "N/A"
              }
              Loading Location Town:${
                Array.isArray(record["productOriginDetails"])
                  ? record["productOriginDetails"]?.map((item, index) =>
                      index === record.length - 1
                        ? item?.locationName
                        : item?.locationName
                    )
                  : record["productOriginDetails"]["locationName"]
                  ? record["productOriginDetails"]["locationName"]
                  : "N/A"
              }
              Ordered on:${moment(record?.dateordered).format("DD/MM/YYYY")}
              Requested Delivery Date:${record?.deliveryReqDate}
              Status:${
                (record.deliveryTruck.includes("Customer Pickup") ||
                  record.deliveryTruck === "CustomerPickup") &&
                record["orderStatus"] === "OP"
                  ? "Pending Customer Pickup"
                  : (record.deliveryTruck.includes("Customer Pickup") ||
                      record.deliveryTruck === "CustomerPickup") &&
                    record["orderStatus"] === "D"
                  ? "Customer Picked Up"
                  : record["orderStatus"] === "PC" && record["tags"].length > 0
                  ? "Pending Carrier"
                  : record["carrierRequests"] && record["orderStatus"] !== "AC"
                  ? "Assigned "
                  : AppConfigs["DISPLAY_LEAD_STATUS"]["admin"]
              }
              Customer:${record?.companyName}
              Location:${
                record["cartItems"][0]["address"] &&
                record["cartItems"][0]["address"] !== null &&
                record["cartItems"][0]["address"].split(",").length > 0
                  ? record["cartItems"][0]["address"].split(",")[1] +
                    ", " +
                    record["cartItems"][0]["address"].split(",")[2]
                  : record.address
              }
              Carrier:${
                record?.assignCarrier
                  ? record["carrierDetails"]["carrierName"]
                  : record["carrierRequests"] &&
                    record["carrierRequests"].length > 0
                  ? "Need Carrier Approvals"
                  : "N/A"
              }
              Pickup Date:${
                record?.pickupDate
                  ? moment(record?.pickupDate).format("DD/MM/YYYY")
                  : "N/A"
              }
              Delivery Date:${
                record?.deliveryDateAndTime
                  ? moment(record?.deliveryDateAndTime).format("DD/MM/YYYY")
                  : "N/A"
              }
              Rate:${
                record?.callForRate
                  ? "Call for Rate"
                  : record["rateValue"]
                  ? `${record["rateValue"]} / ${record["rateOption"]}`
                  : "N/A"
              }
              Type Of Truck:${
                Array.isArray(record["cartItems"][0]["deliveryTruck"])
                  ? record["cartItems"][0]["deliveryTruck"]?.map(
                      (item, index) =>
                        index ===
                        record["cartItems"][0]["deliveryTruck"].length - 1
                          ? item
                          : item
                    )
                  : record["cartItems"][0]["deliveryTruck"]
              }
              `}
            >
              <GlobalStyle />
              {id}
            </Tooltip>
          </div>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Product Name</div>,
        dataIndex: "productName",
        key: "productName",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (productName, record) => (
          <div style={{ color: "black" }}>
            {record?.size + "-" + productName}
          </div>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Loading Location Company</div>,
        dataIndex: "productOriginDetails",
        key: "productOriginDetails",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (record) => (
          <div style={{ color: "black" }}>
            {Array.isArray(record)
              ? record?.map((item, index) =>
                  index === record.length - 1
                    ? item["address"] && item["locationName"]
                    : item["address"] && `${item["locationName"]},`
                )
              : record["address"] && record["locationName"]}
          </div>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Loading Location Town</div>,
        dataIndex: "productOriginDetails",
        key: "productOriginDetails",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (record) => (
          <div style={{ color: "black" }}>
            {Array.isArray(record)
              ? record?.map((item, index) =>
                  index === record.length - 1
                    ? item["address"] &&
                      item["address"].split(",")[1] +
                        "-" +
                        item["address"].split(",")[2]
                    : item["address"] &&
                      `${
                        item["address"].split(",")[1] +
                        "-" +
                        item["address"].split(",")[2]
                      },`
                )
              : record["address"] &&
                record["address"].split(",")[1] +
                  "-" +
                  record["address"].split(",")[2]}
          </div>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Ordered on</div>,
        dataIndex: "createdAt",
        key: "createdAt",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (dateordered, record) => (
          <span>
            <div style={{ color: "black" }}>
              {moment(dateordered).format("MM/DD/YYYY")}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Requested Delivery Date</div>,
        dataIndex: "deliveryReqDate",
        key: "deliveryReqDate",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (deliverydaterequested, record) => (
          <span>
            <div style={{ color: "black" }}>{deliverydaterequested}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Status</div>,
        key: "orderStatus",
        dataIndex: "orderStatus",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (tag, record) => (
          <span className="status_tag">
            <Tag
              color={AppConfigs["STATUS_COLORS"][tag]}
              style={{
                color: "black",
                height: "27px",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {
                // record["markAsDeleted"]
                //   ? AppConfigs["DISPLAY_LEAD_STATUS"]["admin"]["DELETE"]
                //   : record["markAsNew"]
                //   ? AppConfigs["DISPLAY_LEAD_STATUS"]["admin"]["N"]
                //   : record["markAsPaid"]
                //   ? AppConfigs["DISPLAY_LEAD_STATUS"]["admin"]["PAID"]
                //   : record["markAsInvoiced"]
                //   ? AppConfigs["DISPLAY_LEAD_STATUS"]["admin"]["INV"]
                //   :

                (record.deliveryTruck.includes("Customer Pickup") ||
                  record.deliveryTruck === "CustomerPickup") &&
                record["orderStatus"] === "OP"
                  ? "Pending Customer Pickup"
                  : (record.deliveryTruck.includes("Customer Pickup") ||
                      record.deliveryTruck === "CustomerPickup") &&
                    record["orderStatus"] === "D"
                  ? "Customer Picked Up"
                  : record["orderStatus"] === "PC" && record["tags"].length > 0
                  ? "Pending Carrier"
                  : record["carrierRequests"] && record["orderStatus"] !== "AC"
                  ? "Assigned "
                  : AppConfigs["DISPLAY_LEAD_STATUS"]["admin"][tag]
              }
            </Tag>
            {AppConfigs["PUSH_TO_CARRIER"] === tag && (
              <div className="subtext" style={{ color: "grey" }}>
                {record.tagNames.join(", ")}
              </div>
            )}
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Customer</div>,
        dataIndex: "customerName",
        key: "customerName",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (customer, record) => (
          <span>
            <div style={{ color: "black" }}>{record.companyName}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Location</div>,
        dataIndex: "location",
        key: "location",
        // width:"150px",
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (location, record) => (
          <span>
            <div className="subtext" style={{ color: "grey" }}>
              {record["cartItems"][0]["address"] &&
              record["cartItems"][0]["address"] !== null &&
              record["cartItems"][0]["address"]?.split(",").length > 0
                ? record["cartItems"][0]["address"]?.split(",")[1] +
                  ", " +
                  record["cartItems"][0]["address"]?.split(",")[2]
                : record.address}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Carrier</div>,
        dataIndex: "assignCarrier",
        key: "assignCarrier",
        render: (assignCarrier, record) => (
          <span>
            {assignCarrier ? (
              <div style={{ color: "black" }}>
                {record["carrierDetails"]["carrierName"]}
              </div>
            ) : (
              record["carrierRequests"] &&
              record["carrierRequests"].length > 0 && (
                <div
                  style={{ color: "blue" }}
                  onClick={() => {
                    this.setState({
                      carrierRequestsModalStatus: true,
                      carrierRequests: record["carrierRequests"],
                    });
                  }}
                >
                  Need Carrier Approvals
                </div>
              )
            )}
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Type Of Truck</div>,
        dataIndex: "deliveryTruck",
        key: "deliveryTruck",
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (order, record) =>
          Array.isArray(record["cartItems"][0]["deliveryTruck"]) ? (
            record["cartItems"][0]["deliveryTruck"]?.map((item, index) =>
              index === record["cartItems"][0]["deliveryTruck"].length - 1 ? (
                <span key={index + 1}>
                  <div style={{ color: "black" }}>{item}</div>
                </span>
              ) : (
                <span key={index + 1}>
                  <div style={{ color: "black" }}>{item},</div>
                </span>
              )
            )
          ) : (
            <div style={{ color: "black" }}>
              {record["cartItems"][0]["deliveryTruck"]}
            </div>
          ),
      },
      {
        title: <div style={{ color: "grey" }}>Pickup Date</div>,
        dataIndex: "pickupDate",
        key: "pickupDate",
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (pickupDate, record) => (
          <span>
            <div style={{ color: "black" }}>
              {pickupDate && moment(pickupDate).format("MM/DD/YYYY")}
            </div>
            <div className="subtext" style={{ color: "grey" }}>
              {record["pickupStartTime"] &&
                record["pickupStartTime"] + " - " + record["pickupEndTime"]}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Delivery Date</div>,
        dataIndex: "deliveryDateAndTime",
        key: "deliveryDateAndTime",
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (deliveryDateAndTime) => (
          <span>
            <div style={{ color: "black" }}>
              {deliveryDateAndTime &&
                moment(deliveryDateAndTime).format("MM/DD/YYYY")}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>$ to Truck</div>,
        dataIndex: "callForRate",
        key: "callForRate",
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/loads/loaddetails/" + record.id),
        }),
        render: (callForRate, record) => (
          <span>
            <div style={{ color: "black" }}>
              {callForRate ? (
                <h3>Call for Rate</h3>
              ) : (
                record["rateValue"] && (
                  <h3>
                    ${record["rateValue"]} / {record["rateOption"]}
                  </h3>
                )
              )}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Action</div>,
        dataIndex: "id",
        key: "id",
        render: (id, record) => (
          <Dropdown
            overlay={menu(id, record)}
            placement="bottomRight"
            className="orders-dropdown"
          >
            <Button>...</Button>
          </Dropdown>
        ),
      },
    ];

    const menu = (id, record) => (
      <Menu>
        {record.orderStatus === "P" && (
          <Menu.Item className="blue">
            <span
              style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }}
              onClick={() => {
                this.orderConfirm(id);
              }}
            >
              Confirm Order
            </span>
          </Menu.Item>
        )}
        {!record.pushToCarrier &&
          record["orderStatus"] &&
          record["orderStatus"] === "OP" && (
            <Menu.Item className="blue">
              <span
                style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }}
                onClick={() => {
                  this.setState({ showPushToCarrierModal: true });
                }}
              >
                PushToCarrier
              </span>
              {this.state.showPushToCarrierModal && (
                <PushToCarrier
                  leadData={record}
                  callFrom="orders"
                  show={this.state.showPushToCarrierModal}
                  hideModal={this.hidePushToCarrierModal}
                  getOrders={() => this.getOrders()}
                />
              )}
            </Menu.Item>
          )}
        {(record["orderStatus"] === "PC" || record["orderStatus"] === "OP") && (
          <Menu.Item className="blue">
            <AssignToCarrier
              leadData={record}
              callFrom="orders"
              getOrders={() => this.getOrders()}
            />
          </Menu.Item>
        )}
        {record.orderStatus === AppConfigs["IN_PROGRESS"] && (
          <Menu.Item className="blue">
            <LoadDelivered
              leadData={record}
              callFrom="orders"
              getOrders={() => this.getOrders()}
            />
          </Menu.Item>
        )}
        {record.orderStatus === AppConfigs["DELIVERED"] && (
          <>
            <Menu.Item className="blue">
              <span
                style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }}
                onClick={() => {
                  this.markAsStatus("markAsInvoiced", id);
                }}
              >
                Mark as Invoiced
              </span>
            </Menu.Item>
            <Menu.Item className="blue">
              <span
                style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }}
                onClick={() => {
                  this.markAsStatus("markAsPaid", id);
                }}
              >
                Mark as Paid
              </span>
            </Menu.Item>
          </>
        )}
        {/* { (record.orderStatus === AppConfigs["DELIVERED"]) &&  */}
        <Menu.Item className="blue">
          <GeneratePdf
            leadData={record}
            callFrom="orders"
            pathName="loads"
            startLoading={() => this.setState({ pageLoadingStatus: true })}
            stopLoading={() => this.setState({ pageLoadingStatus: false })}
          />
          {/* <span style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }} onClick={() => generatePDF(record)}>Download PDF</span> */}
        </Menu.Item>
        {/* } */}
      </Menu>
    );
    const carrierRequestsColumns = [
      {
        title: <div style={{ color: "grey" }}>Carrier</div>,
        dataIndex: "assignCarrier",
        key: "assignCarrier",
        render: (assignCarrier, record) => (
          <span>
            <div style={{ color: "black" }}>
              {record["carrierDetails"]["carrierName"]}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}></div>,
        dataIndex: "id",
        key: "id",
        render: (id, record) => (
          <span>
            <Button
              type="success"
              onClick={() => this.LoadAssign(id)}
              style={{
                margin: "15px",
                background: "green",
                borderColor: "green",
                color: "rgb(255, 255, 255)",
              }}
              icon="check"
            >
              Approve
            </Button>
          </span>
        ),
      },
    ];
    if (
      this.state.userDetails.userProfile !== "A" &&
      this.state.userDetails.userProfile !== "M"
    ) {
      return <ErrorPage />;
    }

    return (
      <div className="content-outer">
        <div className="content">
          <Spin spinning={this.state.pageLoadingStatus}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <h1 className="headings"> Load List </h1>
              </Col>
              <Row style={{ marginTop: "10px" }}>
                <Col xs={24} sm={24} md={4} lg={4} style={{ marginTop: "1%" }}>
                  <Search
                    className="products-search"
                    size="large"
                    placeholder="Search"
                    onChange={(event) => this.searchData(event, "text")}
                  />
                </Col>
                <Col xs={24} sm={24} md={2} lg={2} style={{ marginTop: "1%" }}>
                  <div className="vl" />
                </Col>
                <Col xs={24} sm={24} md={3} lg={3} style={{ marginTop: "1%" }}>
                  <div className="loads-select">
                    <Select
                      onChange={(event) => this.searchData(event, "status")}
                      defaultValue="All Status"
                      value={this.state.defaultStatus}
                      notFoundContent={"Not found?!"}
                      style={{ width: 180 }}
                    >
                      <Option key="All" value="">
                        All Status
                      </Option>
                      <Option key="N" value="N">
                        <Tooltip placement="rightBottom" title={"New"}>
                          New
                        </Tooltip>
                      </Option>
                      <Option key="OP" value="OP">
                        <Tooltip placement="rightBottom" title={"Available"}>
                          Available
                        </Tooltip>
                      </Option>
                      <Option key="PC" value="PC">
                        <Tooltip
                          placement="rightBottom"
                          title={"Pending Carrier"}
                        >
                          Pending Carrier
                        </Tooltip>
                      </Option>
                      <Option key="AC" value="AC">
                        <Tooltip placement="rightBottom" title={"Assigned"}>
                          Assigned
                        </Tooltip>
                      </Option>
                      <Option key="D" value="D">
                        <Tooltip placement="rightBottom" title={"Delivered"}>
                          Delivered
                        </Tooltip>
                      </Option>
                      <Option key="INV" value="INV">
                        <Tooltip placement="rightBottom" title={"Invoiced"}>
                          Invoiced
                        </Tooltip>
                      </Option>
                      <Option key="PAID" value="PAID">
                        <Tooltip placement="rightBottom" title={"Paid"}>
                          Paid
                        </Tooltip>
                      </Option>
                      <Option key="R" value="R">
                        <Tooltip
                          placement="rightBottom"
                          title={"Customer Canceled"}
                        >
                          Customer Canceled
                        </Tooltip>
                      </Option>
                      <Option key="DELETE" value="DELETE">
                        <Tooltip placement="rightBottom" title={"Deleted"}>
                          Deleted
                        </Tooltip>
                      </Option>
                    </Select>
                  </div>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={15}
                  lg={15}
                  style={{ marginTop: "1%" }}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={this.state.loading}
                    onClick={() => this.addLoad()}
                    className="customer-add-button"
                    icon="plus"
                  >
                    Add Load
                  </Button>
                </Col>
              </Row>
              <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: "2%" }}>
                <div className="loadstable" style={{ overflowX: "auto" }}>
                  <ResizableAntdTable
                    bordered={true}
                    columns={columns}
                    dataSource={this.state.loadsList}
                    loading={this.state.dataLoadingStatus}
                    rowKey={(record) => record.id}
                    pagination={{
                      defaultPageSize: 10,
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "25", "50", "100"],
                      total: this.state.loadsList.length,
                      showTotal: showTotal,
                    }}
                    onChange={(pagination, filters, sorter) => {
                      this.setState({
                        loadsList: ordersSort(
                          pagination,
                          filters,
                          sorter,
                          this.state.loadsList
                        ),
                      });
                    }}
                    onRow={(r) => ({
                      style: { cursor: "pointer" },
                    })}
                  />
                </div>
              </Col>

              <Modal
                visible={this.state.carrierRequestsModalStatus}
                closable={true}
                footer={[
                  <Button
                    key="cancel"
                    className="cancel"
                    onClick={() => {
                      this.setState({ carrierRequestsModalStatus: false });
                    }}
                  >
                    Cancel
                  </Button>,
                ]}
              >
                <div>
                  <Row>
                    <div className="loadstable" style={{ overflowX: "auto" }}>
                      <Table
                        columns={carrierRequestsColumns}
                        dataSource={this.state.carrierRequests}
                        loading={this.state.dataLoadingStatus}
                        rowKey={(record) => record.id}
                        onRow={(r) => ({
                          style: { cursor: "pointer" },
                        })}
                      />
                    </div>
                  </Row>
                </div>
              </Modal>
              <Button>
              <DownloadCsv
                data={this.state.loadsList}
                columns={columns}
                filename="Load List"
              />
            </Button>
            </Row>
          </Spin>
        </div>
      </div>
    );
  }
}

export default Form.create({ name: "loads" })(
  withAppContext(withRouter(Loads))
);
// export default withAppContext(withRouter(Loads));
